module.exports = __webpack_public_path__ + "static/media/Eating Healthy on a Budget First Lithonia Medical Center.ccdaf829.png";